import tinycolor from 'tinycolor2';

var Theme;
(function (Theme) {
  Theme.getLight = function (primaryColor) {
    return {
      cardBackground: 'white',
      cardBorder: '$deepBlue3',
      cardShadow: 'rgba(0,0,0,.1)',
      cardHoverBackground: 'rgba(0,0,0,.05)',
      cardHoverBorder: tinycolor(primaryColor.value).setAlpha(0.6).toHslString(),
      cardActiveBackground: 'rgba(0,0,0,.03)',
      cardActiveBorder: '$primary',
      cardGhostBackground: '$deepBlue2'
    };
  };
  Theme.getDark = function (primaryColor) {
    return {
      cardBackground: '$deepBlue2',
      cardBorder: '$deepBlue3',
      cardShadow: 'transparent',
      cardHoverBackground: 'rgba(255,255,255,.12)',
      cardHoverBorder: tinycolor(primaryColor.value).setAlpha(0.6).toHslString(),
      cardActiveBackground: 'rgba(255,255,255,.07)',
      cardActiveBorder: tinycolor(primaryColor.value).setAlpha(0.4).toHslString(),
      cardGhostBackground: '$deepBlue1'
    };
  };
})(Theme || (Theme = {}));

export { Theme };
